<template>
  <div id="campus-photos">
    <Header :page="'photos'" :title_one="'gift_pga'" :banner_docsok_msg="doc_ok"></Header>

    <div class="container">
      <v-container id="photo-grid" grid-list-sm fluid>
        <v-layout row wrap>
          <v-flex :key="1" xs12 sm4 md3 d-flex>
            <v-card class="picture"> </v-card>
          </v-flex>
          <v-flex :key="2" xs12 sm4 md3 d-flex>
            <v-card class="picture">
              <v-img
                src="/img/gift_pga.jpg"
                lazy-src="/img/gift_pga.jpg"
                aspect-ratio="1"
                class="grey lighten-2"
                @click="preview('/img/gift_pga.jpg')"
              >
              </v-img>
              <div class="actions">
                <!-- <div class="action download" @click="download(photo)">{{$t('campus.download')}}</div> -->
                <!-- <div class="action download" @click="preview(photo)">{{$t('campus.download')}}</div> -->
                <button
                  class="action download"
                  @click="preview('/img/gift_pga.jpg')"
                >
                  {{ $t("campus.download") }}
                </button>
                <!-- <div class="action preview" >{{$t('campus.preview')}}</div> -->
              </div>
            </v-card>
          </v-flex>
          <v-flex :key="3" xs12 sm4 md3 d-flex>
            <v-card class="picture"> </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Header from "@/components/layout/Header";

export default {
  name: "campus_photos",
  components: {
    i18n,
    Header
  },
  data() {
    return {
      participant: {},

      photos: false,

      error: {}
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/getUser"];
    },
    event() {
      return this.$store.getters.getCurrentEvent();
    },
    doc_ok() {
      let person = this.$store.getters['person/getPerson']
      if (
          (!person.antithermal && [4, 5].includes(this.event.type_id)) ||
          !person.medicines ||
          !person.externals ||
          !person.image_right
        ) {
          return false
        }
        return true
    }
  },
  methods: {
    download(photo) {
      var link = document.createElement("a");
      link.download = photo;
      link.href = photo;
      link.click();
    },

    preview(photo) {
      var win = window.open(photo, "_blank");
      win.focus();
    },

    load() {
      var self = this;

      this.$store
        .dispatch("person/loadPersonCampus", {
          campus_id: this.user.event_id,
          participant_id: this.user.participant_id
        })
        .then(function() {
          self.participant = self.$store.getters["person/getPerson"];
          self.$store
            .dispatch("person/loadPhotos", {
              campus_id: self.user.event_id,
              participant_id: self.user.participant_id
            })
            .then(function(data) {
              self.photos = data && data.length > 0 ? data : false;
            });
        });
    }
  },
  created() {
    this.$store.commit("setCampus", true);
    this.load();
  }
};
</script>

<style lang="scss">
#campus-photos {
  h5,
  .download {
    display: inline-block;
  }
  .title {
    font-size: 24px !important;
    font-weight: bold;
  }
  .container {
    padding: 0;
    margin: 20px 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    .banner {
      @include display-flex();
      @include align-items();
      @include flex-wrap(wrap);
      @include background(
        $color: #f0f0f0,
        $image: img("no-photo.svg"),
        $position: left 25px center,
        $size: 40px
      );
      width: fit-content;
      // min-height: 100px;
      height: auto;
      padding: 30px;
      padding-left: 80px;
      margin: 24px auto;
      border-radius: 3px;

      .info {
      }
      .text {
        display: inline-block;
        font-size: 14px;
        margin: 0;
        padding: 0;
        color: #111;
        font-family: AvantGarde-Bold;
      }
      .message_error {
        color: #666;
        display: inline-block;
        font-size: 16px;
        margin-top: 5px;
      }

      .actions {
        @include display-flex();
        @include align-items();
        @include flex-wrap(wrap);
        display: inline-block;
        width: 300px;
        height: 100%;
        text-align: right;
      }
      .value {
        margin: 0;
        padding: 0;
        display: inline-block;
        width: 80px;
        padding: 7px;
        border: 1px solid $warning-color;
        color: $warning-color-text;
        border-radius: 3px;
        font-size: 22px;
        text-align: center;
        background: #fff;
        vertical-align: top;
      }
      .btn {
        display: inline-block;
        width: auto;
        background-color: #fc8926;
        font-family: AvantGarde-Bold;
        color: #fff;
        border-radius: 3px;
        padding: 10px 25px;
        margin-left: 16px;
        border: none;
        border: 1px solid transparent;
        text-transform: none;
        vertical-align: top;
      }

      &.error {
        .value {
          border-color: $alert-color;
          color: $alert-color;
        }
      }

      &.hide {
        display: none;
      }
    }

    #photo-grid {
      width: 90%;
      margin: 0 auto;
      .picture {
        box-shadow: none;
        margin-bottom: 1.75em;

        .actions {
          padding-top: 15px;
          margin: 0 auto;
          text-align: center;
          // background-color: #eee;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-around;

          button {
            // width: 125px !important;
            text-align: center;
            padding: 0 15px;
            margin: 0;
            height: 100%;
            min-width: 40px;
            outline: none;
            cursor: pointer;
            font-size: 8pt;
            font-family: Speedee-Bold;
            // margin-top: 5px;
            border-radius: 3px;
            border: 1px solid #fc8926;
            background-color: transparent;
            color: #fff;
            height: 40px;
            font-family: Roboto-Bold;
            font-size: 14px;
            line-height: 14px;
            transition: background-color 0.5s ease;
            vertical-align: middle;
            margin: 0 auto;
            background-color: #fc8926;

            background-color: white;
            border: 2px solid #fc8926;
            transition: 0.25s ease;

            &.action {
              width: fit-content;
              display: inline-block;
              font-size: 22px;
              font-weight: bold;
              cursor: pointer;
              color: #fc8926;

              &.download {
                @include background(
                  $image: img("download_orange.svg"),
                  $position: left 15px center,
                  $size: 20px
                );
                padding-left: 40px;
              }
              &.preview {
                @include background(
                  $image: img("expand_orange.svg"),
                  $position: left center,
                  $size: 20px
                );
                padding-left: 30px;
              }
            }

            &:hover {
              background-color: #fc8a2623 !important;
              color: white;

              &.download {
                @include background(
                  $image: img("download.svg"),
                  $position: left 15px center,
                  $size: 20px
                );
                padding-left: 40px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
